// extracted by mini-css-extract-plugin
module.exports = {"selection":"menu-incentive_selection__Bnsbr","selectGroup":"menu-incentive_selectGroup__b3r_d"};